export default "__VITE_ASSET__Cynwn$sp__"